var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var toCamelCase = function (s) {
    return s.replace(/([-_][a-z])/gi, function ($1) {
        return $1.toUpperCase().replace('-', '').replace('_', '');
    });
};
export var toSnakeCase = function (s) {
    return s.replace(/[A-Z]/g, function (letter) { return "_".concat(letter.toLowerCase()); });
};
var mapKeysToCase = function (root, finalCase, options, _path, _stopRecursionEarly) {
    if (options === void 0) { options = {}; }
    if (_path === void 0) { _path = []; }
    if (_stopRecursionEarly === void 0) { _stopRecursionEarly = options.checkShouldRecursionStop &&
        options.checkShouldRecursionStop(_path); }
    return _stopRecursionEarly || !root
        ? root
        : root.constructor === Array
            ? root.map(function (o, i) { return mapKeysToCase(o, finalCase, options, _path.concat(i)); })
            : root.constructor === Object
                ? Object.keys(root).reduce(function (acc, key) {
                    var _a;
                    return (__assign((_a = {}, _a[(finalCase === 'camel' ? toCamelCase : toSnakeCase)(key)] = options.recursive && !_stopRecursionEarly
                        ? mapKeysToCase(root[key], finalCase, options, _path.concat(key))
                        : root[key], _a), acc));
                }, {})
                : root;
};
// NOTE: This only converts the keys at the root level
export var mapSnakeKeysToCamelKeys = function (obj) {
    return mapKeysToCase(obj, 'camel');
};
// NOTE: This only converts the keys at the root level
export var mapCamelKeysToSnakeKeys = function (obj) {
    return mapKeysToCase(obj, 'snake');
};
export function mapSnakeKeysToCamelKeysRecursively(obj, options) {
    if (options === void 0) { options = {}; }
    return mapKeysToCase(obj, 'camel', __assign({ recursive: true }, options));
}
export var mapCamelKeysToSnakeKeysRecursively = function (obj, options) {
    if (options === void 0) { options = {}; }
    return mapKeysToCase(obj, 'snake', __assign({ recursive: true }, options));
};
